import { mapActions, mapGetters, mapMutations } from 'vuex'
import ProviderSources from '@/helper/ProviderSources'
import VueJsonPretty from 'vue-json-pretty'
import ConfirmSave from '@/components/modals/confirm-save/index.vue'


export default {
  props: {
    readonly: {
      required: false,
      type: Boolean,
      default: false
    },
    providerItem: {
      required: true,
      type: Object,
      default: ''
    }
  },
  components: {
    VueJsonPretty,
    ConfirmSave
  },
  data () {
    return {
      rules: {
        mock: () => (!this.mock || !!this.isValidJSONString) || 'O JSON informado não é válido'
      },
      mock: null,
      viewMock: false,
      name: '',
      supplier: null,
      category: null,
      cost: 0,
      isLoading: false,
      isLoadingParamField: false,
      isLoadingAddFieldAvailable: false,
      isLoadingFieldRequired: false,
      isLoadingInternalField: false,
      dialog: false,
      fieldName: '',
      paramName: '',
      paramValue: '',
      requestField: '',
      newFieldInternal: '',
      costMetrics: [
        { name: 'Alta', value: 'alta' },
        { name: 'Baixa', value: 'baixa' },
        { name: 'Local', value: 'local' }
      ],
      selectedType: '',
      description: '',
      providerSources: ProviderSources,
      providerClassification: [],
      selectedProviderClassification: '',
      selectedProviderSources: '',
      selectedFieldAvailable: {},
      selectedParamField: {},
      selectedFieldRequired: {},
      selectedInternalField: {},
      selectedParamFieldToView: {},
      managerConfirmSave: false,
      titleConfirmSave: 'Tem certeza que deseja alterar o valor de custo?',
      messageConfirmSave: 'Ao realizar esta ação todas as cestas dos clientes serão alteradas.',
      metrics: [
        { name: 'Alto', value: '5ba98593-3fa1-40b3-b773-6a0a25f8931a' },
        { name: 'Baixo', value: '8b322de6-61d2-487a-bd93-fee10f480334' },
        { name: 'Local', value: '63c68219-d34c-43d9-98e7-82595e1c05df' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getterSelectedSystemProvider',
      'getterPlanType',
      'getterSystemProviderClassifications'
    ]),
    isValidJSONString () {
      let result = null

      try {
        result = JSON.parse(this.mock)
      } catch (e) {
        result = null
      }

      return result
    },
    idSelectedProvider () {
      return this.getterSelectedSystemProvider.idSystemProvider
    },
    idPlanTypes () {
      return this.getterPlanType
    },
    isDisabled () {
      return this.selectedType === '' || !this.minimumPrice || !this.cost || (this.mock && !this.isValidJSONString) || (this.getterSelectedSystemProvider && this.getterSelectedSystemProvider.fieldsAvaliableOnProvider && this.getterSelectedSystemProvider.fieldsAvaliableOnProvider.length === 0) || (this.getterSelectedSystemProvider && this.getterSelectedSystemProvider.requestFields && this.getterSelectedSystemProvider.requestFields.length === 0)
    },
    options () {
      return {
        loading: this.isLoadingParamField || this.isLoading
      }
    },
    optionsAddFieldAvailable () {
      return {
        loading: this.isLoadingAddFieldAvailable && Object.keys(this.selectedFieldAvailable).length === 0
      }
    },
    optionsAddFieldRequired () {
      return {
        loading: this.isLoadingFieldRequired && Object.keys(this.selectedFieldRequired).length === 0
      }
    },
    optionsInternalField () {
      return {
        loading: this.isLoadingInternalField && Object.keys(this.selectedInternalField).length === 0
      }
    }
  },
  mounted () {
    this.setProviderInfo()
    this.getSystemProviderClassification()
    this.mapProvider(this.providerItem)
  },
  beforeDestroy () {
    this.SET_SELECTED_SYSTEM_PROVIDER()
  },
  methods: {
    ...mapActions([
      'actionEditSystemProvider',
      'actionRemoveFieldAvailable',
      'actionAddFieldAvailable',
      'actionAddParamsFields',
      'actionEditParamsFields',
      'actionAddRequestFields',
      'actionRemoveRequestFields',
      'actionEditRequestFields',
      'actionGetAllSystemProviders',
      'actionGetSystemProviderClassifications',
      'actionGetSystemProviderSalesValues',
      'actionPatchSystemProvider'
    ]),
    ...mapMutations([
      'SET_SELECTED_SYSTEM_PROVIDER'
    ]),
    confirmResponse () {
      this.managerConfirmSave = false
      this.isLoading = this.dialog = false
      const cost = Number(this.cost.replace(',', '.'))
      this.actionPatchSystemProvider({
        idSystemProvider: this.providerItem.idSystemProvider,
        metricTypeId: this.selectedMetrics,
        cost
      }).then(() => {
        this.sendToast({
          text: 'Valor de provider alterado com sucesso',
          type: 'success'
        })
      }).catch(() => {
        this.sendToast({
          text: 'Erro ao alterar valor de provider',
          type: 'danger'
        })
      })
    },
    async getSystemProviderClassification () {
      this.actionGetSystemProviderClassifications().then((response) => {
        this.providerClassification = response.data.map((item) => ({
          label: item.name,
          value: item.idSystemProviderClassification
        }))
      }).catch((error) => {
        console.log(error)
      })
    },
    mapProvider (provider) {
      const spc = this.getterSystemProviderClassifications.find((item) => item.idSystemProviderClassification === provider.idSystemProviderClassification)
      this.name = provider.name
      this.supplier = provider.sourceName ? provider.sourceName : 'Não atribuído'
      this.category = spc ? spc.name : 'Não atribuída'
      this.cost = parseFloat(provider.cost).toFixed(2)
      this.selectedMetrics = provider.metricTypeId
    },
    closeModal () {
      this.isLoading = this.dialog = false

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    },
    setParamFieldToEdit (item) {
      this.selectedParamFieldToView = {}

      if (Object.keys(this.selectedParamField).length === 0 || (item.idParamsField !== this.selectedParamField.idParamsField)) {
        const {
          name,
          value
        } = item

        this.paramName = name
        this.paramValue = value

        this.selectedParamField = item
      } else {
        this.paramName = ''
        this.paramValue = ''
        this.selectedParamField = {}
      }
    },
    setParamFieldToView (item) {
      const {
        name,
        value
      } = item

      this.paramName = name
      this.paramValue = value

      this.selectedParamField = {}
      this.selectedParamFieldToView = item
    },
    cleanFields () {
      this.paramName = this.paramValue = ''
      this.selectedParamFieldToView = this.selectedParamField = {}
    },
    managerParamField () {
      if (Object.keys(this.selectedParamFieldToView).length === 0) {
        this.isLoadingParamField = true

        if (Object.keys(this.selectedParamField).length === 0) {
          const paramField = {
            name: this.paramName,
            value: this.paramValue,
            idSystemProvider: this.getterSelectedSystemProvider.idSystemProvider
          }

          this.actionAddParamsFields(paramField)
            .then(() => {
              this.paramName = this.paramValue = ''

              this.isLoadingParamField = false
            })
            .catch(() => {
              this.sendToast({
                text: 'Ocorreu um erro ao adicionar o ParamField, tente novamente mais tarde!',
                type: 'danger'
              })

              this.isLoadingParamField = false
            })
        } else {
          const updatedParams = {
            ...this.selectedParamField,
            value: this.paramValue
          }

          this.actionEditParamsFields(updatedParams)
            .then(() => {
              this.paramName = this.paramValue = ''
              this.selectedParamField = {}

              this.isLoadingParamField = false
            })
            .catch(() => {
              this.sendToast({
                text: 'Ocorreu um erro ao editar o ParamField, tente novamente mais tarde!',
                type: 'danger'
              })

              this.isLoadingParamField = false
            })
        }
      } else {
        this.sendToast({
          text: 'Você está visualizando um ParamField!',
          type: 'warning'
        })
      }
    },
    setProviderInfo () {
      this.dialog = true

      if (Object.keys(this.getterSelectedSystemProvider).length > 0) {
        this.minimumPrice = this.getterSelectedSystemProvider.minimumPrice.toString()
        this.cost = this.getterSelectedSystemProvider.cost.toString()
        this.selectedProviderSources = this.getterSelectedSystemProvider.sourceName
        this.selectedProviderClassification = this.getterSelectedSystemProvider.idSystemProviderClassification
        this.description = this.getterSelectedSystemProvider.description
        this.mock = this.getterSelectedSystemProvider.mock

        if (Object.prototype.hasOwnProperty.call(this.getterSelectedSystemProvider, 'type')) {
          this.selectedType = this.getterSelectedSystemProvider.type
        }

        if (this.minimumPrice.indexOf('.') === -1) {
          this.minimumPrice = `${this.minimumPrice},00`
        } else {
          const val = this.minimumPrice.split('.')

          if (val[1] !== undefined && val[1].length === 1) {
            this.minimumPrice = `${this.minimumPrice.replace('.', ',')}0`
          } else {
            this.minimumPrice = this.minimumPrice.replace('.', ',')
          }
        }

        if (this.cost.indexOf('.') === -1) {
          this.cost = `${this.cost},00`
        } else {
          const val = this.cost.split('.')

          if (val[1] !== undefined && val[1].length === 1) {
            this.cost = `${this.cost.replace('.', ',')}0`
          } else {
            this.cost = this.cost.replace('.', ',')
          }
        }
      }
    },
    editCostProvider () {
      this.managerConfirmSave = true
    },
    editProvider () {
      if (!this.isDisabled) {
        const systemProvider = {
          ...this.getterSelectedSystemProvider,
          type: this.selectedType,
          minimumPrice: !this.minimumPrice ? 0 : parseFloat(this.minimumPrice.toString().replace('.', '').replace(',', '.')),
          cost: !this.cost ? 0 : parseFloat(this.cost.toString().replace('.', '').replace(',', '.')),
          sourceName: this.selectedProviderSources.text === undefined ? this.selectedProviderSources : this.selectedProviderSources.text,
          description: this.description,
          mock: this.mock,
          idSystemProviderClassification: this.selectedProviderClassification
        }


        this.isLoading = true

        this.actionEditSystemProvider(systemProvider)
          .then(() => {
            this.closeModal()

            this.actionGetAllSystemProviders()

            this.sendToast({
              text: 'Provider atualizado com sucesso!',
              type: 'success'
            })
          })
          .catch(() => {
            this.sendToast({
              text: 'Ocorreu um erro ao atualizar o provider, tente novamente mais tarde!',
              type: 'danger'
            })

            this.isLoading = false
          })
      } else {
        this.sendToast({
          text: 'Os campos não foram preenchidos corretamente!',
          type: 'warning'
        })
      }
    },
    addFieldAvailable () {
      const fieldAvailable = {
        idSystemProvider: this.getterSelectedSystemProvider.idSystemProvider,
        name: this.fieldName
      }

      this.isLoadingAddFieldAvailable = true

      this.actionAddFieldAvailable(fieldAvailable)
        .then(() => {
          this.fieldName = ''

          this.isLoadingAddFieldAvailable = false
        })
        .catch(() => {
          this.isLoadingAddFieldAvailable = false

          this.sendToast({
            text: 'Ocorreu um erro ao adicionar um campo disponível, tente novamente mais tarde!',
            type: 'danger'
          })
        })
    },
    removeFieldAvaliable (item) {
      this.selectedFieldAvailable = item
      this.isLoadingAddFieldAvailable = true

      this.actionRemoveFieldAvailable(item)
        .then(() => {
          this.isLoadingAddFieldAvailable = false
          this.selectedFieldAvailable = {}
        })
        .catch(() => {
          this.isLoadingAddFieldAvailable = false
          this.selectedFieldAvailable = {}

          this.sendToast({
            text: 'Ocorreu um erro ao remover um campo disponível, tente novamente mais tarde!',
            type: 'danger'
          })
        })
    },
    removeFieldRequired (item) {
      this.selectedFieldRequired = item
      this.isLoadingFieldRequired = true

      this.actionRemoveRequestFields(item)
        .then(() => {
          this.isLoadingFieldRequired = false
          this.selectedFieldRequired = {}
        })
        .catch(() => {
          this.sendToast({
            text: 'Ocorreu um erro ao remover o campo requerido, tente novamente mais tarde!',
            type: 'danger'
          })

          this.isLoadingFieldRequired = false
          this.selectedFieldRequired = {}
        })
    },
    addRequestField () {
      const requestField = {
        name: this.requestField,
        required: false,
        internal: false,
        idSystemProvider: this.getterSelectedSystemProvider.idSystemProvider
      }

      this.isLoadingFieldRequired = true

      this.actionAddRequestFields(requestField)
        .then(() => {
          this.requestField = ''

          this.isLoadingFieldRequired = false
        })
        .catch(() => {
          this.isLoadingFieldRequired = false

          this.sendToast({
            text: 'Ocorreu um erro ao adicionar o campo requerido, tente novamente mais tarde!',
            type: 'danger'
          })
        })
    },
    editInternalField () {
      const params = {
        ...this.newFieldInternal,
        internal: true,
        minimumPrice: !this.minimumPrice ? 0 : parseFloat(this.minimumPrice.toString().replace('.', '').replace(',', '.'))
      }

      this.isLoadingInternalField = true

      this.actionEditRequestFields(params)
        .then(() => {
          this.actionGetAllSystemProviders()

          this.newFieldInternal = ''

          this.isLoadingInternalField = false
        })
        .catch(() => {
          this.sendToast({
            text: 'Ocorreu um erro ao atualizar o campo interno, tente novamente mais tarde!',
            type: 'danger'
          })

          this.isLoadingInternalField = false
        })
    },
    deleteInternalField (item) {
      const updatedItem = {
        ...item,
        internal: false
      }

      this.selectedInternalField = item
      this.isLoadingInternalField = true

      this.actionEditRequestFields(updatedItem)
        .then(() => {
          this.sendToast({
            text: 'Campo interno removido com sucesso',
            type: 'success'
          })

          this.selectedInternalField = {}
          this.isLoadingInternalField = false
        })
        .catch(() => {
          this.sendToast({
            text: 'Falha ao remover o InternalField',
            type: 'danger'
          })

          this.selectedInternalField = {}
          this.isLoadingInternalField = false
        })
    }
  }
}
